import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  CircularProgress,
  InputAdornment,
  ListSubheader,
} from "@mui/material";
import { styled } from "@mui/system";
import { showSmallLoadingImage,showLoadingImage } from "../Utility/Utility";
import { getLinkedServices, getServicesAddedToBill } from "../API/LinkedServicesApi";
const BoldListSubheader = styled(ListSubheader)(({ theme }) => ({
  fontWeight: "bold",
}));

const AddServiceDialog = ({
  open,
  onClose,
  onSave,
  linkedServices,
  selectedServiceId,
  setSelectedServiceId,
  selectedService,
  setSelectedService,
  discountInPercentage,
  setDiscountInPercentage,
  loading,
  isSaving,
  visitId, // loading state for save operation
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <DialogTitle sx={{ fontWeight: 600, fontSize: "20px" }}>
        Add New Service
      </DialogTitle>
      <DialogContent dividers>
        <FormControl fullWidth margin="normal">
          <InputLabel>Linked Services</InputLabel>
          
          <Select
            label="Linked Services"
            value={selectedServiceId}
            onChange={(e) => {
              setSelectedServiceId(e.target.value);
              setSelectedService(
                linkedServices.find((s) => s.id === e.target.value)
              );
            }}
          >
            <BoldListSubheader>
              Billed Services (
              {
                linkedServices.filter(
                  (service) => service.billingStatus === "AddedToBill"
                ).length
              }
              )
            </BoldListSubheader>
            {linkedServices
              .filter((service) => service.billingStatus === "AddedToBill")
              .map((service) => (
                <MenuItem key={service.id} value={service.id} disabled>
                  {service.serviceName}
                </MenuItem>
              ))}

            <BoldListSubheader>
              Unbilled Services (
              {
                linkedServices.filter(
                  (service) => service.billingStatus === "NotBilled"
                ).length
              }
              )
            </BoldListSubheader>
            {linkedServices
              .filter((service) => service.billingStatus === "NotBilled")
              .map((service) => (
                <MenuItem key={service.id} value={service.id}>
                  {service.serviceName}
                </MenuItem>
              ))}
          </Select>
        </FormControl>

        <TextField
          label="Billable Amount"
          fullWidth
          margin="normal"
          type="number"
          step="0.01"
          value={selectedService?.fees}
          InputProps={{
            startAdornment: <InputAdornment position="start">Rs</InputAdornment>,
            readOnly: true,
          }}
          InputLabelProps={{ shrink: true }}
        />

        <TextField
          label="Discount (%)"
          fullWidth
          margin="normal"
          type="number"
          value={discountInPercentage}
          onChange={(e) => setDiscountInPercentage(e.target.value)}
          InputProps={{
            endAdornment: <InputAdornment position="end">%</InputAdornment>,
          }}
        />

        <TextField
          label="Final Billable Amount"
          fullWidth
          margin="normal"
          type="number"
          value={(
            selectedService?.fees - 
            (selectedService?.fees * discountInPercentage) / 100
          ).toFixed(2)}
          InputProps={{
            startAdornment: <InputAdornment position="start">Rs</InputAdornment>,
            readOnly: true,
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="inherit">
          Close
        </Button>
        {isSaving && (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(216, 214, 214, 0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1301, // One level above Dialog
      }}
    >
      {showLoadingImage()}
    </div>
  )}

  {/* Save button */}
  <Button
    onClick={onSave}
    variant="contained"                 
    color="secondary"
    disabled={isSaving}
  >
    Save
  </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddServiceDialog;